import { api } from '@/api/client';
export async function createOrder(body) {
    const { data } = await api.post('/v1/orders', body);
    return data;
}
